
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

/**
 * Represents a base widget for Brs.
 */
export class BrsBaseWidget extends kendo.ui.Widget {
	/**
     * Registers a BrsWidget class.
     *
     * @param cls - The BrsWidget class to register.
     * @param name - The name of the widget. Defaults to the class name.
     */
	static registerBrsWidget(cls: any, name: string = cls.name) {
		cls.fn = cls.prototype;
		cls.fn.options = $.extend(true, {}, BrsBaseWidget.fn.options);
		cls.fn.options.name = name;
		kendo.ui.plugin(cls);
	}

	constructor(selector: Element, options?: Record<string, unknown>) {
		super(selector, options);
		super.init(this.element);
	}
}

// Create an alias of the prototype (required by kendo.ui.plugin).
BrsBaseWidget.fn = BrsBaseWidget.prototype;
// Deep clone the widget default options.
BrsBaseWidget.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
